import React from 'react'
import Panel from 'react-bootstrap/lib/Panel'

import SubjectSummary from './subject-summary'
import BillingDetails from './billing-details'

const Wrapper = ({ data }) => (
  <Panel header="Billing Assessment">
    <div className="row">
      <SubjectSummary data={data.get('subjects')} total={data.getIn(['meta', 'total_units'])} />
      <BillingDetails data={data} />
      <div className="col-sm-12">
        <hr />
        <small className="text-muted"><em>*** Billing Assessment updated at: {data.getIn(['meta', 'updated_date'])}</em></small><br />
        <small className="text-muted"><em>*** You may request a printed copy of this Billing Assessment at the EDP Office.</em></small>
      </div>
    </div>
  </Panel>
)

export default Wrapper



// WEBPACK FOOTER //
// ./src/containers/Billing/wrapper.js